(function () {
  function getOffset(root) {
    var styles = window.getComputedStyle(root);
    var announcementOffset = parseFloat(styles.getPropertyValue('--announcement-offset')) || 0;
    var headerOffset = parseFloat(styles.getPropertyValue('--header-offset')) || 0;

    return announcementOffset + headerOffset + 16;
  }

  function animateScrollTo(root, targetTop) {
    if (root._faqScrollFrame) window.cancelAnimationFrame(root._faqScrollFrame);

    var startTop = window.scrollY;
    var maxTop = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var destination = Math.max(0, Math.min(targetTop, maxTop));
    var distance = destination - startTop;
    if (Math.abs(distance) < 2) return;

    var duration = Math.min(650, Math.max(420, Math.abs(distance) * 0.45));
    var startTime = null;

    function step(timestamp) {
      if (startTime === null) startTime = timestamp;
      var progress = Math.min(1, (timestamp - startTime) / duration);
      var easedProgress = 1 - Math.pow(1 - progress, 4);

      window.scrollTo(0, startTop + distance * easedProgress);

      if (progress < 1) {
        root._faqScrollFrame = window.requestAnimationFrame(step);
      } else {
        root._faqScrollFrame = null;
      }
    }

    root._faqScrollFrame = window.requestAnimationFrame(step);
  }

  function scrollIfObscured(root, item, delay) {
    window.setTimeout(function () {
      window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var rect = item.getBoundingClientRect();
        var visibleTop = getOffset(root);
        var visibleBottom = window.innerHeight - 16;

        if (rect.top >= visibleTop && rect.bottom <= visibleBottom) return;

        animateScrollTo(root, window.scrollY + rect.top - visibleTop);
      });
      });
    }, delay || 0);
  }

  function animateAccordion(item, shouldOpen) {
    var body = item.querySelector('.faq__acc-body');

    if (!body) {
      item.open = shouldOpen;
      item.classList.remove('is-closing');
      return Promise.resolve();
    }

    var animationId = (item._faqAnimationId || 0) + 1;
    item._faqAnimationId = animationId;

    var wasOpen = item.open;
    var startPadding = wasOpen ? getComputedStyle(body).paddingTop : '0px';
    var startPaddingBottom = wasOpen ? getComputedStyle(body).paddingBottom : '0px';
    var currentHeight = wasOpen ? body.getBoundingClientRect().height : 0;
    if (shouldOpen && !item.open) item.open = true;
    if (!shouldOpen) item.classList.add('is-closing');

    var endPaddingTop = shouldOpen ? '18px' : '0px';
    var endPaddingBottom = shouldOpen ? '8px' : '0px';

    body.style.overflow = 'hidden';
    body.style.height = currentHeight + 'px';
    body.style.paddingTop = startPadding;
    body.style.paddingBottom = startPaddingBottom;
    body.style.opacity = shouldOpen && currentHeight === 0 ? '0' : '1';
    body.style.transform = shouldOpen && currentHeight === 0 ? 'translateY(-8px)' : 'translateY(0)';
    body.style.transition = 'none';
    void body.offsetHeight;

    body.style.transition = 'height 360ms cubic-bezier(0.22, 1, 0.36, 1), padding 360ms cubic-bezier(0.22, 1, 0.36, 1), opacity 280ms ease, transform 360ms cubic-bezier(0.22, 1, 0.36, 1)';

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        body.style.paddingTop = endPaddingTop;
        body.style.paddingBottom = endPaddingBottom;
        var endHeight = shouldOpen ? body.scrollHeight : 0;
        body.style.height = endHeight + 'px';
        body.style.opacity = shouldOpen ? '1' : '0';
        body.style.transform = shouldOpen ? 'translateY(0)' : 'translateY(-8px)';
      });
    });

    return new Promise(function (resolve) {
      var settled = false;
      var finish = function () {
        if (settled) return;
        settled = true;
        if (item._faqAnimationId !== animationId) {
          resolve();
          return;
        }

        item.open = shouldOpen;
        item.classList.remove('is-closing');
        body.style.removeProperty('height');
        body.style.removeProperty('opacity');
        body.style.removeProperty('overflow');
        body.style.removeProperty('transform');
        body.style.removeProperty('transition');
        resolve();
      };

      body.addEventListener('transitionend', function onTransitionEnd(event) {
        if (event.propertyName !== 'height') return;
        body.removeEventListener('transitionend', onTransitionEnd);
        finish();
      });
      window.setTimeout(finish, 450);
    });
  }

  function initFaq(root) {
    if (!root || root.dataset.faqInitialized === 'true') return;

    root.dataset.faqInitialized = 'true';
    document.body.classList.add('has-faq-section');

    var questions = root.querySelectorAll('.faq__desktop .faq__q');
    var panels = root.querySelectorAll('.faq__desktop [data-faq-panel]');
    var accordionItems = root.querySelectorAll('.faq__mobile .faq__acc-item');

    questions.forEach(function (question) {
      question.addEventListener('click', function () {
        var activeIndex = question.dataset.faq;

        questions.forEach(function (item) {
          item.setAttribute('aria-expanded', item === question ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.faqPanel !== activeIndex;
        });

        var activePanel = root.querySelector('[data-faq-panel="' + activeIndex + '"]');
        if (activePanel) scrollIfObscured(root, activePanel, 380);
      });
    });

    accordionItems.forEach(function (item) {
      var summary = item.querySelector('.faq__acc-head');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        var shouldOpen = !item.open || item.classList.contains('is-closing');
        var animations = [];

        accordionItems.forEach(function (otherItem) {
          if (otherItem !== item && otherItem.open) {
            animations.push(animateAccordion(otherItem, false));
          }
        });

        animations.push(animateAccordion(item, shouldOpen));

        Promise.all(animations).then(function () {
          if (shouldOpen && item.open) scrollIfObscured(root, item);
        });
      });
    });
  }

  function initAll(scope) {
    if (scope.matches && scope.matches('[data-faq-root]')) initFaq(scope);
    scope.querySelectorAll('[data-faq-root]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
